class CPSProductSlider {
  constructor(container) {
    this.container = container;
    this.wrapper = container.querySelector('[data-slider-wrapper]');
    this.grid = container.querySelector('[data-product-grid]');
    this.dotsContainer = container.querySelector('.cps-slider-dots');
    this.prevArrow = container.querySelector('[data-slider-prev]');
    this.nextArrow = container.querySelector('[data-slider-next]');
    this.items = container.querySelectorAll('.cps-product-card');
    this.productCount = this.items.length;
    this.isMobile = window.innerWidth < 750;

    if (!this.grid || this.productCount === 0) return;
    this.init();
  }

  init() {
    this.addListeners();
    if (this.isMobile) {
      this.initMobileDots();
    } else {
      this.initDesktopArrows();
    }
  }

  addListeners() {
    this.grid.addEventListener('scroll', this.debounce(this.onMobileScroll.bind(this), 100));
    if (this.prevArrow && this.nextArrow) {
      this.prevArrow.addEventListener('click', this.onPrevClick.bind(this));
      this.nextArrow.addEventListener('click', this.onNextClick.bind(this));
    }

    window.addEventListener('resize', this.onResize.bind(this)); // Ensure dots/arrows adapt on window resize
  }

  initMobileDots() {
    if (this.productCount <= 2) {
      if (this.dotsContainer) this.dotsContainer.hidden = true;
      return;
    }
    this.dotsContainer.innerHTML = '';
    const pageCount = Math.ceil(this.productCount / 2);
    for (let i = 0; i < pageCount; i++) {
      const dot = document.createElement('button');
      dot.className = 'cps-slider-dots__dot';
      dot.dataset.index = i;
      dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
      if (i === 0) dot.classList.add('is-active');
      dot.addEventListener('click', () => {
        const itemIndex = i * 2;
        this.grid.scrollTo({
          left: this.items[itemIndex].offsetLeft - parseInt(getComputedStyle(this.grid).paddingLeft),
          behavior: 'smooth'
        });
      });
      this.dotsContainer.appendChild(dot);
    }
    this.checkMobileDots();
  }

  onMobileScroll() {
    if (window.innerWidth >= 750) return;
    this.checkMobileDots();
  }

checkMobileDots() {
  if (!this.dotsContainer) return;
  const scrollLeft = this.grid.scrollLeft;
  const totalWidth = this.grid.scrollWidth - this.grid.clientWidth;
  const itemWidth = this.items[0].offsetWidth + parseInt(getComputedStyle(this.grid).gap);

  const pageCount = Math.ceil(this.productCount / 2);
  let currentPage;

  // If at (or very close to) the end, activate the last dot
  if (scrollLeft + 2 >= totalWidth) {
    currentPage = pageCount - 1;
  } else {
    currentPage = Math.round(scrollLeft / (itemWidth * 2));
  }

  this.dotsContainer.querySelectorAll('.cps-slider-dots__dot').forEach((dot, i) => {
    dot.classList.toggle('is-active', i === currentPage);
  });
}


  initDesktopArrows() {
    if (this.productCount > 4) {
      this.wrapper.classList.add('slider-desktop--active');
      this.checkArrows();
    }
  }

  onPrevClick() {
    const scrollAmount = this.grid.clientWidth - parseInt(getComputedStyle(this.grid).gap);
    this.grid.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    setTimeout(() => this.checkArrows(), 400);
  }

  onNextClick() {
    const scrollAmount = this.grid.clientWidth - parseInt(getComputedStyle(this.grid).gap);
    this.grid.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    setTimeout(() => this.checkArrows(), 400);
  }

  checkArrows() {
    if (window.innerWidth < 750) return;
    const scrollLeft = Math.ceil(this.grid.scrollLeft);
    const maxScroll = this.grid.scrollWidth - this.grid.clientWidth;
    if (this.prevArrow) this.prevArrow.disabled = scrollLeft <= 1;
    if (this.nextArrow) this.nextArrow.disabled = scrollLeft >= (maxScroll - 1);
  }

  onResize() {
    const isNowMobile = window.innerWidth < 750;
    if (isNowMobile !== this.isMobile) {
      this.isMobile = isNowMobile;
      if (this.isMobile) {
        this.initMobileDots();
      } else {
        this.dotsContainer.innerHTML = '';
        this.initDesktopArrows();
      }
    }
  }

  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
}

// Initialize for all .cps-section instances after DOM loaded
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll('.cps-section').forEach(section => {
    new CPSProductSlider(section);
  });
});
